export default "__VITE_ASSET__AjoDe00D__"